import axios from 'axios';

const ajax = {
  // 获取i18n种类
  GET_LANGUAGE_TYPE: '/get/i18n_type',

  // 获取首页menuList
  GET_MENU_LIST: 'homePageMenuImgList'

  // 获取头部导航菜单
  // GET_HEADER_LIST: '/headerList',
};

// 获取单个影像件
const GET_IMAGE_BYTE = 'attachment/v1/media/byte'

// 获取有权限的子菜单
const GET_GRANTED_SUBMENU = 'platform/v1/resources/granted/submenu'

const API_PATH_PRE_FIX = '/api';

// 增加前缀
let INTERFACE = {};
for (let key in ajax) {
  INTERFACE[key] = API_PATH_PRE_FIX + ajax[key];
}

const FIRST_PARAM_JOINT_MARK = '?'

// 退出系统
const LOGOUT = 'auth/user/logout'

/**
 * 获取 i18n 的种类
 */
function getI18nType() {
  // 这里需要先调用后端保存的语言
  return axios.get(INTERFACE.GET_LANGUAGE_TYPE);
}

/**
 * 获取i18n 配置json
 *
 * @param language
 * @private
 */
function getI18n(language = 'zh') {
  return axios.get('/static/i18n/' + language + '/index.json' + '?').then((data) => {
    window.I18n = data;
  });
}

/**
 * 获取头部导航菜单
 */
// function getHeaderList() {
//   return axios.get(INTERFACE.GET_HEADER_LIST).catch(function (error) {
//     console.log(error)
//   });
// }
function getHeaderList() {
  var data = {
    parentMenuValue: '/',
    serviceName: window.localStorage.serviceName,
    httpMethod: 'GET',
    parentType: 'FRONTEND_DOMAIN',
    childType: 'FRONTEND_URL'
  }
  return axios.get(GET_GRANTED_SUBMENU + '?', {params: data}).catch(function (error) {
    console.log(error)
  });
}

/**
 * 获取首页menuList
 */
function getMenuList() {
  return axios.get(INTERFACE.GET_MENU_LIST).catch(function (error) {
    // window.Alert(error);
    console.log(error)
  });
}

/**
 * 获取单个影像件
 * @param data
 * @returns {Promise.<T>}
 */
function getImageByte(data) {
  return axios.get(GET_IMAGE_BYTE + FIRST_PARAM_JOINT_MARK, {
    params: data
  }).catch(function (error) {
    // window.Alert(error);
    console.log(error)
  });
}

function getPolicyIstrue(data) {
  return axios.get('policy/v1/ciq/verify?', {
    params: data
  }).catch(function (error) {
    // window.Alert(error);
    console.log(error)
  });
}

function getPolicyDetail(data) {
  return axios.get('policy/v1/ciq/policy?', {
    params: data
  }).catch(function (error) {
    // window.Alert(error);
    console.log(error)
  });
}

function getPolicyeBook(data) {
  return axios.get('policy/v1/policy/email?', {
    params: data
  }).catch(function (error) {
    // window.Alert(error);
    console.log(error)
  });
}

function logout() {
  return axios.get(LOGOUT + FIRST_PARAM_JOINT_MARK).catch(function (error) {
    // window.Alert(error);
    console.log(error)
  });
}

function printPdf(data) {
  return axios.post('policy/v1/policy/download', data).catch(function (error) {
    // window.Alert(error);
    console.log(error)
  });
}

export default {
  getI18n,
  getI18nType,
  getHeaderList,
  getImageByte,
  getMenuList,
  logout,
  getPolicyIstrue,
  getPolicyeBook,
  getPolicyDetail,
  printPdf
};



// WEBPACK FOOTER //
// ./src/interface.js